module.exports = __webpack_public_path__ + "img/finish_line.bba25de8.svg";